import { useContext } from 'react'

import { EnvContext } from './EnvProvider'

/** Public readonly interface for EnvContext. */
export const useEnv = () => {
  const env = useContext(EnvContext)
  return env
}
